import gql from 'graphql-tag';

export const fields = `
    value
    createdAt
    updatedAt
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateChartTypes (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateChartTypes (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetChartTypes (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetChartTypes (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindChartTypeById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindChartTypeById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindChartType (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindChartType (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateChartType (
        $payload: DigitaiCreateChartTypeInput!
    ) {
        digitaiCreateChartType (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateChartTypes (
        $payload: [DigitaiCreateChartTypeInput]!
    ) {
        digitaiCreateChartTypes (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateChartTypeById (
        $payload: DigitaiUpdateChartTypeByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateChartTypeById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateChartTypes (
        $payload: DigitaiUpdateChartTypesInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateChartTypes (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteChartTypeById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteChartTypeById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteChartTypes (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteChartTypes (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
